import { toPrintableObject } from 'src/utils/strings';

type QueryKeyValue<T> = T extends string | number | boolean
	? T
	: T extends null | undefined
		? never
		: string;

type QueryKeyTuple<T extends readonly unknown[]> = {
	[K in keyof T]: QueryKeyValue<T[K]>;
};

/**
 * Creates a query key that contains items UP TO the first nullish argument.
 */
export function createQueryKey<
	const TLabel extends string,
	const T extends readonly unknown[],
>(label: TLabel, ...args: T): [TLabel, ...QueryKeyTuple<T>] {
	const baseKey = [label, ...args];

	const queryKey: string[] = [];

	for (const key of baseKey) {
		if (key == null) {
			break;
		}

		if (Array.isArray(key) || typeof key === 'object') {
			// Stringify arrays and objects.
			queryKey.push(JSON.stringify(toPrintableObject(key)));
		} else {
			// Primitives can be mapped to string
			queryKey.push(key.toString());
		}
	}

	return queryKey as [TLabel, ...QueryKeyTuple<T>];
}
